<template lang="pug">
  v-list-item.px-0
    v-list-item-action.align-self-start.mt-1.mr-5
      div
        .black--text: strong {{ lesson.date_start.split(" ")[1] }}
        .grey--text: strong {{ lesson.date_end.split(" ")[1] }}

    v-card.sdo-card.primary.lighten-5.black--text.pa-2.fill-width
      .d-flex.px-1
        .black--text.text-subtitle-2.align-center.d-flex.pb-0
          v-icon(color="primary") $telegram
          span Телеграм трансляция

        v-spacer

        v-menu(v-if="$user.isTeacher && !$user.studentMode")
          template(#activator="{ on }")
            v-btn(v-on="on" icon small)
              v-icon mdi-dots-vertical

          v-list.pa-2.secondary
            v-list-item(
              @click="open(lesson)"
            )
              v-list-item-icon.mr-4: v-icon(color="white") mdi-pencil
              v-list-item-title.white--text Изменить

            v-list-item(@click="deb")
              v-list-item-icon.mr-4: v-icon(color="white") mdi-delete
              v-list-item-title.white--text Удалить

      .text-body-2.black--text.mt-2.px-2.mb-1: strong {{ lesson.title }}
      v-card-actions.py-0.px-0
        v-btn(
          depressed text color="primary"
          :disabled="!lesson.conference || lesson.isForbidden"
          target="_blank"
          dark
          :href="lesson.conference ? lesson.conference.group.invite_link : ''"
        ) Перейти
</template>
<script>
import ConferenceFormTelegram from './Conference/ConferenceFormTelegram.vue';

export const CONFERENCE_SOURCE = {
  telegram: 1,
  jazz: 2,
};

export default {
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deb() {
      this.$emit('open', this.lesson.id);
    },
    open(item) {
      this.$modals.show('generic-controller', {
        component: ConferenceFormTelegram,
        title: 'Редактирование конференции',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          successCallback: ({ data }) => {
            this.$modals.close();
            this.$toasted.success('Успешно');
            item.date_start = data.data.date_start;
            item.date_end = data.data.date_end;
            item.title = data.data.title;
          },
          id: item.id,
          data: {
            title: item.title,
            date: item.date_start.split(' ')[0],
            duration: {
              start: item.date_start.split(' ')[1],
              end: item.date_end.split(' ')[1],
            },
          },
          isEdit: true,
        },
      });
    },
  },
};
</script>
